// src/components/layout/MainLayout.js
import React from 'react';
import { Outlet } from 'react-router-dom'; // <-- Importante: Outlet
import Navbar from './Navbar';
import { useSessionTimeout } from '../../hooks/useSessionTimeout';

const MainLayout = () => {
  // Vigila el vencimiento del token SAP (notifica + cierra sesión + redirige).
  useSessionTimeout();

  return (
    <>
      <Navbar /> {/* El Navbar se renderiza aquí */}

      <div className="container mt-4">
        {/* Outlet renderizará el componente de la ruta hija (Dashboard, Articulos, etc.) */}
        <Outlet /> 
      </div>
    </>
  );
};

export default MainLayout;